import { name, version } from '../package.json';

export default {
    iconOnly: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'When true changes the Previous and Next page buttons to be icon-only.',
        },
    },
    nextText: {
        type: String,
        default: 'Next',
        docs: {
            validation: '—',
            description: 'Sets the Next button text.',
        },
    },
    onDark: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'If `true`, changes component to on-dark styling.',
        },
    },
    page: {
        type: Number,
        default: 1,
        docs: {
            validation: '—',
            description: 'Sets the currently selected page.',
        },
    },
    pageSize: {
        type: Number,
        docs: {
            validation: '—',
            description: 'Sets number of items per page. Must match one of the values in `pageSizes`.',
        },
    },
    pageSizes: {
        type: Array,
        default: () => [10, 20, 50, -1],
        docs: {
            validation: '—',
            description: 'Sets the options in the show items per page select. `-1` displays all items.',
        },
    },
    prevText: {
        type: String,
        default: 'Prev',
        docs: {
            validation: '—',
            description: 'Sets the Previous button text.',
        },
    },
    showItemsInfo: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description:
                'When true, displays details describing the items currently shown and the total number of items paginated.',
        },
    },
    showItemsSelect: {
        type: Boolean,
        default: false,
        docs: {
            validation: '—',
            description: 'When true, displays the select that allows a user to set the number of items per page.',
        },
    },
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
        },
        docs: {
            validation: '—',
            description: 'Sets the size of the pagination.',
        },
    },
    totalItems: {
        type: Number,
        required: true,
        docs: {
            validation: '—',
            description: 'Sets the total number of items being paginated.',
        },
    },
    version: {
        type: String,
        default: `${name}-${version}`,
        docs: {
            validation: 'Read-only',
            description:
                'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
        },
    },
};
